import { legacySunsetDate } from '../allowlist';

// Advisory shown above the auth card when a sign-in is using the legacy
// #payload= handoff — allowed only for the BrowserKit extension, and only
// until VITE_LEGACY_SSO_SUNSET_AT (see allowlist.ts). Once that instant
// passes, this same request hits App.tsx's 'needs-update' blocked phase
// instead of reaching this banner at all.
export function ExtensionSunsetBanner() {
  const sunset = legacySunsetDate();

  return (
    <div className="mb-4 rounded-xl border border-amber-300 bg-amber-50 p-4 shadow-sm dark:border-amber-400/30 dark:bg-amber-400/10">
      <div className="flex items-center gap-2">
        <svg
          className="h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
          />
        </svg>
        <p className="text-sm font-semibold text-amber-700 dark:text-amber-300">Update available</p>
      </div>
      <p className="mt-1.5 text-left text-xs leading-relaxed text-amber-600 sm:text-sm dark:text-amber-400">
        {sunset ? (
          <>
            This sign-in method stops working on{' '}
            <span className="font-semibold">
              {sunset.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}
            </span>
            . Update your SellersFlow extension from the Chrome Web Store before then to avoid being
            signed out.
          </>
        ) : (
          <>
            A newer, more secure sign-in method is available. Update your SellersFlow extension from
            the Chrome Web Store when you can.
          </>
        )}
      </p>
    </div>
  );
}
